// Domain 02 check helpers — all read live (cloned) simulator state.
import { stpVlan, channelMembers, memberFlag, trunkAllows } from '../../engine/net/l2.js';
import { ifStatus } from '../../engine/net/sim.js';
import { clone } from '../../engine/net/model.js';
export * from '../d01/helpers.js';

export function stpOf(rt, v) { return stpVlan(clone(rt.net), v); }
export function rootOf(rt, v, sw) { return stpOf(rt, v).bridges[sw]?.root; }
export function rootPort(rt, v, sw) { return stpOf(rt, v).bridges[sw]?.rootPort; }
export function portState(rt, v, sw, lp) { return stpOf(rt, v).ports[`${sw}|${lp}`]; }
/** All members of a Port-channel bundled (P) and at least `n` of them. */
export function bundled(rt, sw, po, n = 2) {
  const m = channelMembers(clone(rt.net), sw, po);
  return m.length >= n && m.every((x) => x.flag === 'P');
}
export const flagOf = (rt, sw, ifc) => memberFlag(clone(rt.net), sw, ifc);
export function isTrunk(rt, sw, port, { native, allowed } = {}) {
  const i = rt.net.devices[sw].interfaces[port];
  if (!i || i.mode !== 'trunk') return false;
  if (native != null && (i.nativeVlan || 1) !== native) return false;
  if (allowed && !allowed.every((v) => trunkAllows(i, v))) return false;
  return true;
}
export const accessIn = (rt, sw, port, v) => { const i = rt.net.devices[sw].interfaces[port]; return i?.mode !== 'trunk' && i?.accessVlan === v; };
export const upIf = (rt, sw, ifc) => ifStatus(clone(rt.net), sw, ifc).protocol === 'up';
export const vlanNamed = (rt, sw, v, name) => rt.net.devices[sw].vlans[v]?.name?.toUpperCase() === name;
